module.exports = __webpack_public_path__ + "img/bg-7.1.3be6c119.jpg";